class Cursor {
	constructor(str, containers, pos) {
		this.str = str;
		this.containers = containers;
		this.startedAt = this.position = pos;
	}

	reset() {
		return (this.position = this.startedAt);
	}

	isSameContainerAt(i) {
		var c1 = this.containers[this.position];
		var c2 = this.containers[this.position + i];
		return c1 === c2;
	}

	isWhiteSpaceCharacter(ch) {
		const whitespaceCharacters = new Set([' ', '\t', '\n', '\r']);

		return whitespaceCharacters.has(ch);
	}

	isWhiteSpaceAt(i) {
		const ch = this.str.charAt(this.position + (i || 0));
		return this.isWhiteSpaceCharacter(ch);
	}

	forward() {
		this.position += 1;
	}

	backward() {
		this.position -= 1;
	}

	get ch() {
		return this.str.charAt(this.position);
	}

	get moved() {
		return this.position - this.startedAt;
	}

	get nextChar() {
		return this.str.charAt(this.position + 1);
	}

	get previousChar() {
		return this.str.charAt(this.position - 1);
	}

	get canMoveForward() {
		return this.position < this.str.length;
	}

	get canMoveBackward() {
		return this.position > 0;
	}

	get isWhiteSpace() {
		return this.isWhiteSpaceCharacter(this.ch);
	}

	get atEnd() {
		return this.position >= this.str.length;
	}

	get atStart() {
		return this.position <= 0;
	}
}

module.exports = Cursor;
